'use strict';

const SoaModel = require('../SoaModel');
const TwentyFirstCenturyStatus = module.exports = SoaModel.extend();
const ends = require('dibs-endpoints');
const _ = require('underscore');

_.extend(TwentyFirstCenturyStatus.prototype, {
    url: function () {
        return ends.sellerTwentyFirstCenturyStatus(this.id);
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/TwentyFirstCenturyStatus.es.js